mutation DeletePracticeRecording($id: ID!) {
  deletePracticeRecording(id: $id) {
    ok
    errors
  }
}
